import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AuthChooseOrganisation } from '../components/auth/ChooseOrganisation';
import { AuthForgot } from '../components/auth/Forgot';
import { AuthInvite } from '../components/auth/Invite';
import { AuthLogin } from '../components/auth/Login';
import { AuthReset } from '../components/auth/Reset';
import { AuthSignUp } from '../components/auth/sign-up';
import { useMaintenanceCheck } from '../Maintenance';
import { useStores } from '../stores';

export const AuthRouter = () => {
  useMaintenanceCheck();

  const { authStore } = useStores();

  return (
    <div className="Auth">
      <Switch>
        {authStore.isAuthorized ? (
          <Route exact path="/auth" render={() => <Redirect to="/" />} />
        ) : (
          <Route exact path="/auth" component={AuthLogin} />
        )}
        <Route
          exact
          path="/auth/organisations"
          component={AuthChooseOrganisation}
        />
        <Route exact path="/auth/forgot" component={AuthForgot} />
        <Route exact path="/auth/reset" component={AuthReset} />
        <Route exact path="/auth/sign-up" component={AuthSignUp} />
        <Route exact path="/auth/invite" component={AuthInvite} />
        <Route path="*" render={() => <Redirect to="/auth" />} />
      </Switch>
    </div>
  );
};
